import React, { useState } from "react";
import styled, { keyframes } from "styled-components";

const DocsPage = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <DocsContainer>
      {!loaded && <Loading>Loading Docs...</Loading>}
      <Iframe
        src="/docs/index.html"
        title="API Docs"
        allowFullScreen
        onLoad={() => setLoaded(true)}
      />
    </DocsContainer>
  );
};

export default DocsPage;

const DocsContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const Iframe = styled.iframe`
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  border: none;
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Loading = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  transform: translate(-50%, -50%);
  color: #496264;
  font-size: 16px;
  animation: ${fadeIn} 0.4s ease-in-out;
`;
